import React from 'react';
import './BenefitsGrid.css';

const BenefitsGrid = () => {
  const benefits = [
  {
    title: "ECONOMIA EM TODO LUGAR",
    description: "Garanta seu direito à meia-entrada em cinemas, shows, teatros e eventos esportivos em todo o território nacional.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-ticket-icon lucide-ticket"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M13 5v2"/><path d="M13 17v2"/><path d="M13 11v2"/></svg>
  },
  {
    title: "BENEFÍCIOS EXCLUSIVOS",
    description: "Acesso a um ecossistema de descontos em grandes lojas, farmácias e serviços que você já usa no seu dia a dia.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-gift-icon lucide-gift"><path d="M12 7v14"/><path d="M20 11v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8"/><path d="M7.5 7a1 1 0 0 1 0-5A4.8 8 0 0 1 12 7a4.8 8 0 0 1 4.5-5 1 1 0 0 1 0 5"/><rect x="3" y="7" width="18" height="4" rx="1"/></svg>
  },
  {
    title: "VALIDAÇÃO DIGITAL INSTANTÂNEA",
    description: "Sua identificação sempre à mão. Aprovação agilizada para você não perder tempo em filas ou processos burocráticos.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-smartphone-icon lucide-smartphone"><rect width="14" height="20" x="5" y="2" rx="2" ry="2"/><path d="M12 18h.01"/></svg>
  },
  {
    title: "SUPORTE PRIORITÁRIO",
    description: "Equipe preparada para auxiliar você em qualquer dúvida, garantindo que seus direitos sejam sempre respeitados.",
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-handshake-icon lucide-handshake"><path d="m11 17 2 2a1 1 0 1 0 3-3"/><path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"/><path d="m21 3 1 11h-2"/><path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"/><path d="M3 4h8"/></svg>
  }
];

  return (
    <section className="container">
      <header className="header">
        <h2>Descubra por que a UEN é</h2>
        <h1 className="highlight">LÍDER ABSOLUTA no Brasil!</h1>
      </header>

      <div className="grid">
        {benefits.map((benefit, index) => (
          <div key={index} className="card">
            <div className="icon-container">
              {benefit.icon}
            </div>
            <h3 className="card-title">{benefit.title}</h3>
            <p className="card-description">{benefit.description}</p>
            <div className="card-footer-line"></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BenefitsGrid;